import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { SentimentMixedOutlined, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import messageUtil from 'utils/messageUtil'
import SoundbiteSentiment from 'enums/SoundbiteSentiment'
import MetadataIconsContainer from './MetadataIconsContainer'
import { StyledSentimentContainer } from '../index.css'

const SentimentMixedIcon = () => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  const color = sys[theme].semantic.middle.default
  const message = messageUtil.sentimentSingular(SoundbiteSentiment.MIXED)
  const tooltip = `${t('sentimentClassification')}: ${message}`

  return (
    <Tooltip mode={theme} enabled content={tooltip}>
      <StyledSentimentContainer>
        <MetadataIconsContainer message={message}>
          <SentimentMixedOutlined color={color} />
        </MetadataIconsContainer>
      </StyledSentimentContainer>
    </Tooltip>
  )
}

export default SentimentMixedIcon
